import React from 'react';
import PropTypes from 'prop-types';

class BackboneViewWrapper extends React.PureComponent {
  componentDidMount() {
    const { backboneView } = this.props;

    this.node.appendChild(backboneView.render().el);
  }

  componentWillUnmount() {
    const { backboneView } = this.props;

    backboneView.remove();
  }

  render() {
    const { className } = this.props;

    return <div className={className} ref={(node) => { this.node = node; }} />;
  }
}

BackboneViewWrapper.propTypes = {
  backboneView: PropTypes.instanceOf(Object).isRequired,
  className: PropTypes.string,
};

BackboneViewWrapper.defaultProps = {
  className: '',
};

export default BackboneViewWrapper;
